import React from 'react';

export const DashboardContext = React.createContext(null);
export const DashboardChestContext = React.createContext(null);
export const DashboardViewChestContext = React.createContext(null);
